<template>
<div class="monitoringall">
    <el-dropdown trigger="click" @command="handleCommand">
    <span class="el-dropdown-link" >
        {{itemTitle}}<i class="el-icon-arrow-down el-icon--right"></i>
    </span>
            
    <el-dropdown-menu slot="dropdown" >
        <!-- <div id="inp">
        <input id="div-inp" text="checkbox" v-model="felice" />
        <div id="sousuo">
            <i class="el-icon-search"></i>
        </div>
        </div>
        <div v-if="IsShow > 0" class="NoShow">{{ textNo }}</div> -->
        <div class="hodern">
          <el-tree  ref="tree" :data="treeList" default-expand-all  @node-click="nodeClick" node-key="deviceId"  >
            </el-tree>
        </div>
    </el-dropdown-menu>
    </el-dropdown>
</div>
</template>
<script>
import { GetSecurityDevices, GET_AREAS } from "../../../api/common";
import { chainIndex } from "../../../api/linkindex";
export default {
name: "png",
data() {
    return {
    IsShow: 0,
    itemTitle: "",
    felice: "",
    id: "",
    areaId: 1,
    targetData: [],
    textNo: "",
      treeList:[]
    };
},
mounted() {
    this.getFloor();
    GET_AREAS().then((res) => {
    let id = 0;
        res.data.data.areas.forEach((item, index) => {
            GetSecurityDevices(item.areaId).then((res) => {
                res.data.data.devices.filter((item) => {
                    if (item.device_class_name == "监控设备") {
                        return this.targetData.push({
                            id: id++,
                            videoName: item.device_name,
                            videoCode: JSON.parse(item.device_details).roomName,
                        });
                    }
                })
            })
        })
    })
    
},
watch: {
    targetData(o, n) {
    if (this.targetData.length == 0) {
        this.IsShow = 1;
        this.textNo = "暂无数据";
    } else {
        this.IsShow = 0;
        this.textNo = "";
        this.itemTitle = this.targetData[0].videoName
        this.$store.commit("monitoringName", this.targetData[0])
    }
    },
    felice(val) {
    this.felice = val;
    var pnge = this.$store.state.homeitem.massage;
    this.targetData = pnge.filter((array) => {
        if (array.videoName.match(this.felice) !== null) {
        return array;
        } else if (this.felice == "") {
        return this.targetData;
        }
    });
    },
},
beforeDestroy() {
    this.$store.commit("apkAll", null);
},
methods: {
    nodeClick(obj,obj2,obj3){
      if(obj.deviceName){
        this.itemTitle = obj.deviceName;
        let videoCode  = JSON.parse(obj.deviceDetails).roomName;
        this.$refs.tree.setCheckedKeys([obj.deviceId]);
        this.$refs.tree.setCurrentKey(obj.deviceId);
        this.$store.commit("apkAll", videoCode);
      }else{
        return
      }
      
    },
    objectOrder(obj) {//排序的函数
      var newkey = Object.keys(obj).sort(); //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
      var newObj = {};//创建一个新的对象，用于存放排好序的键值对
      for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
          newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
      }
      return newObj;//返回排好序的新对象
    },
    getFloor(){
      this.id = this.$store.state.project.currentProject.projectId;
      chainIndex.cameraFloor(this.id).then((res) => {
        let list = res.data.data.devices;
        list.forEach(item=>{
            let data = item.devices.filter(l => {l.label = l.deviceName;l.children=[];return l})
            this.treeList.push({
              label:item.name,
              children:data
            })
        })
      })
    },
    handleCommand(command) {
    this.itemTitle = this.targetData[command].videoName ;
    this.$store.commit("apkAll", this.targetData[command].videoCode);
    },
},
};
</script>
<style scoped lang="less">
/deep/.is-current>.el-tree-node__content{        
  background: #F1F1F1 !important;  
   color:#0D94FF;   
  }
/deep/.el-tree-node__children .el-tree-node__content{
  height: 46rem;
  .el-tree-node__label{
    font-size: 16rem;
  }
}
.custom-tree-node{
  font-size: 16rem;
  img{
    position: absolute;
    right: 10px;
  }
    
}
/deep/.el-tree-node__content{
    height: 56rem;
    // background: #F1F1F1;
    .el-tree-node__label{
      padding-left: 15px;
      font-size: 18rem;
    }
  }
 /deep/ .el-tree-node__expand-icon{
    background: url('../../../assets/img/aright.png') no-repeat;
    display: inline-block;
    position: absolute;
    right: 15px;
    &::before{
      content: none;
    }
  }
  
  /deep/.is-leaf{
    display: none;
    &::before{
      content: none;
    }
  }
.active-item{
  background-color: #ecf5ff;
  color: #66b1ff;
}
/deep/.el-popper[x-placement^=bottom]{
  margin-top: 0!important;
}
/deep/.popper__arrow{
  display: none !important;
}
/deep/.el-dropdown-menu__item{
  line-height: 42px;
}
.tag{
  font-size: 18px;
  img{
    width: 26px;
    vertical-align: middle;
    margin-right: 10rem;
  }
}
    .monitoringall {
        width: 100% !important;
        position: relative;
    }
    .el-dropdown-link {
        left: 30rem;
        top: 20rem;
        width: 500rem;
        position: absolute;
        display: flex;
        color: #ffffff;
        font-size: 18rem;
        cursor: pointer;
        align-items: center;
    }
    ::v-deep .el-dropdown-link:focus {
        outline: none;  
    }
    .el-dropdown-menu {
        width: 260rem !important;
        position: fixed !important;
        left: 16% !important;
        top: 13% !important;
        padding: 0;
    }
    .popper__arrow {
        margin-left: 0 !important;
    }
    .el-dropdown-menu__item {
        white-space: nowrap !important;
    }
    #inp {
        width: 248rem;
        height: 32rem;
        background: rgba(252, 250, 250, 0.15);
        border: 1rem solid rgba(0, 0, 0, 0.15);
        border-radius: 16rem;
        margin-left: 16rem;
        margin-bottom: 16rem;
        padding: 0rem 8rem 0 5rem;
        display: flex;
        justify-content: space-between;
    #div-inp {
        background: rgba(252, 250, 250, 0.15);
        color: #999999;
        .w(120);
        font-size: 16rem;
        border: none;
        outline: none;
    }
    }

    #sousuo {
    //  width: 18rem;
    //  height: 18rem;
    margin-left: 0rem;
    margin-top: 2%;
    .el-icon-search {
        font-size: 16rem;
    }
    }
    .NoShow {
    position: absolute;
    height: 24rem;
    color: gray;
    font-size: 16rem;
    text-align: center;
    top: 80rem;
    left: 0;
    right: 0;
    margin: auto;
    }
    .YesShow {
    height: 24rem;
    width: 100%;
    }
    .hodern {
    width: 260rem !important;
    max-height: 300rem !important;
    // max-height: 300rem;
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    }
    .hodern::-webkit-scrollbar {
    width: 8rem;
    height: 72rem;
    background: #fff;
    }
    div::-webkit-scrollbar-track {
    width: 8rem;
    height: 72rem;
    background: #fff;
    border-radius: 4rem;
    }
    div::-webkit-scrollbar-thumb {
    width: 8rem;
    height: 72rem;
    background: #bfbfbf;
    border-radius: 10rem;
    }
</style>